import React, { useState, useCallback } from "react";
import useInfiniteScroll from "react-infinite-scroll-hook";
import SimpleSpinner from "../../../components/loader";
import { ContractorVM } from "@propertelligent/client-api";
import ContractorCardItem from "../../contractor/ContractorCardItem";

interface DataHookState {
  rows: ContractorVM[];
  loading: boolean;
  hasMore: boolean;
  fetchData: (page: number) => void;
  currentPage: number;
  handleFullRefresh?: () => void;
}

interface ContractorProps {
  id?: string;
  isFooter?: boolean;
  dataHookState: DataHookState;
}

const ContractorCard: React.FC<ContractorProps> = ({
  id,
  isFooter = true,
  dataHookState
}) => {
  const { rows, loading, hasMore, fetchData, currentPage } = dataHookState;

  const loadMoreRecords = useCallback(() => {
    if (!loading && hasMore) {
      fetchData(currentPage + 1);
    }
  }, [loading, hasMore, fetchData, currentPage]);

  const [sentryRef] = useInfiniteScroll({
    loading,
    hasNextPage: hasMore,
    onLoadMore: loadMoreRecords,
    disabled: !hasMore,
    rootMargin: "0px 0px 100px 0px",
  });


  return (
    <div className="infinite-scroll-container">
      {rows.map((listingData) => (
        <ContractorCardItem
          key={listingData.id}
          id={id}
          listingData={listingData}
          isFooter={isFooter}
          fetchData={dataHookState.handleFullRefresh ? dataHookState.handleFullRefresh : () => fetchData(1)}
        />
      ))}

      {(loading || hasMore) && (
        <div ref={sentryRef} className="loading-trigger">
          {loading && (
            <SimpleSpinner
              myClassName={rows.length === 0 ? "Icon50" : "Icon40"}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default React.memo(ContractorCard);